export default __webpack_public_path__ + "static/media/twitter-logo.7a9247c3.svg";